module.exports = __webpack_public_path__ + "images/liinilaevad/routes/NAR-NAJ-NAR-inactive@2x.png";